import React, { useCallback, useEffect, useState } from 'react';
import { getGitSHA } from '../../utils';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { updateCapricaGitShaAction } from '../../redux/slices/auth';
import {
  selectAuthCapricaGitSha,
  selectAuthUpdateAvailable,
} from '../../redux/selectors/auth';
import { useLocation } from 'react-router-dom';

const CHECK_FOR_NEW_VERSION_SECONDS = 30;

export default () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const updateAvailable = useAppSelector(selectAuthUpdateAvailable);
  const capricaGitSha = useAppSelector(selectAuthCapricaGitSha);
  const [timeoutId, setTimeoutId] = useState<number | null>(null);

  // a callback to stop the timer
  const stopChecking = useCallback(() => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  }, [timeoutId]);

  // for debugging and testing purpose, log when new version is available and the GITSHA
  useEffect(() => {
    if (updateAvailable) {
      console.info(
        `A new version of Caprica is available with GITSHA: [${capricaGitSha}]`,
      );
    }
  }, [updateAvailable, capricaGitSha]);

  // check updateAvailable only if the url changed.
  // this is because we don't want to interrupt user in the middle of his work
  // when url changed, it means user finished his work already.
  // for example: click executing or save on dashboard.
  useEffect(() => {
    if (updateAvailable) {
      window.location.reload();
    }
    // eslint-disable-next-line
  }, [location]);

  // fetch gitsha every 30 seconds and update it to redux.
  useEffect(() => {
    const loadGitSha = async () => {
      const gitSha = await getGitSHA();
      dispatch(updateCapricaGitShaAction(gitSha));
      setTimeoutId(
        window.setTimeout(loadGitSha, CHECK_FOR_NEW_VERSION_SECONDS * 1000),
      );
    };

    (async () => await loadGitSha())();

    return stopChecking;
    // this componentDidMount hook
    // eslint-disable-next-line
  }, []);

  return <></>;
};
